<template>
	<div class="table-options" :class="$vuetify.breakpoint.smAndDown ? 'd-none': ''">
		Viewing:
		<v-select
			class="mx-5"
			v-model="select_receipt_type"
			:items="statuses"
			append-icon="mdi-chevron-down"
			:menu-props="{ bottom: true, offsetY: true }"
			color="rgba(25, 42, 62, 0.7)"
			item-color=""
			solo
			dense
			hide-details
			@change="onStatusChange()"
		>
			<template slot="item" slot-scope="data">
				<v-icon class="mr-1" v-if="select_receipt_type === data.item.value">mdi-check</v-icon>
				<div v-else class="mr-7"></div>
				{{data.item.text}}
			</template>
		</v-select>
		<v-select
			v-model="select_customise_view"
			:items="customise_view"
			label="Customise View"
			append-icon="mdi-chevron-down"
			:menu-props="{ bottom: true, offsetY: true}"
			color="rgba(25, 42, 62, 0.7)"
			item-color="white"
			solo
			dense
			hide-details
			multiple
			@change="onCustomiseChange()"
		>
			<template v-slot:selection="{ index }">
				<span style="padding-top: 2px" v-if="index === 0">Customise View</span>
				<span v-if="index === 1"></span>
			</template>
			<template v-slot:item="{item, on, attrs}">
				<v-list-item v-on="on">
					<v-simple-checkbox
						:value="attrs.inputValue"
						v-on="on"
						color="info"
						:ripple="false"
					></v-simple-checkbox>
					<span class="checkbox-text ml-4"> {{ item.text }}</span>
				</v-list-item>
			</template>
		</v-select>
	</div>
</template>
<script>

export default {
	name: 'ReceiptView',
	props: {
		typeSelected: {
			type: String,
			default: ''
		},
		viewSelected: {
			type: Array,
			default: () => []
		},
		statuses: {
			type: Array,
			default: () => []
		},
		customise_view: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			select_receipt_type: this.typeSelected, 
			select_customise_view: [],
		}
	},
	watch: {
		typeSelected() {
			this.select_receipt_type = this.typeSelected;
		},
		viewSelected() {
			this.select_customise_view = this.viewSelected;
		},
	},
	methods: {
		onStatusChange() {
			this.$emit('status', this.select_receipt_type);
		},
		onCustomiseChange() {
			this.$emit('column', this.select_customise_view);
		}
	}
}
</script>
<style lang="scss" scoped>
.table-options {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  div {
    width: 200px;
  }
}
.checkbox-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #192A3E;
}
.v-list--dense .v-list-item {
  min-height: 32px;
}
</style>